export const CHANGE_SUMMARY_DATA = 'CHANGE_SUMMARY_DATA';
export const SET_LOADING = '[SUMMARY DATA] SET_LOADING';
